const adapt = httpResponse => ({
  ...httpResponse,
  data: httpResponse.data.map(empresa => ({
    id: empresa.empresa,
    name: empresa.nomeFantasia,
    logoPath: empresa.logomarcaPath,
    tipoNome: empresa.tipoNome,
  })),
});

const getAllCompaniesAdapter = httpResponsePromise =>
  httpResponsePromise.then(
    resolve => adapt(resolve),
    reject => Promise.reject(reject),
  );

export { getAllCompaniesAdapter };
